import script from "./SlidedMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./SlidedMenu.vue?vue&type=script&setup=true&lang=js"

import "./SlidedMenu.vue?vue&type=style&index=0&id=1719084b&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1719084b"]])

export default __exports__